import React from "react";
import AddOrganizations from "../Organizations/AddOrganizations";
import { useOrganization } from "../../lib/context/OrganisationContext";
import Spin from "../../components/Spin";

const EditOrganization = () => {
  const { organizationData } = useOrganization();
  return (
    <div className="relative">
      {organizationData?.organizationId ? (
        <AddOrganizations
          edit={true}
          orgId={organizationData?.organizationId}
          tab={true}
        />
      ) : (
        <Spin />
      )}
    </div>
  );
};

export default EditOrganization;
